import React from 'react';

// Pages
import HomePage from './pages/HomePage';
import { ContentContextPage } from './pages/ContentContextPage';
import { ContentPage } from './pages/ContentPage';
import { QuestionsPage } from './pages/QuestionsPage';
import { AnswersPage } from './pages/AnswersPage';
import { NotificationConfigurationPage } from './pages/NotificationConfiguration';
import { UserListPage } from './pages/UsersListPage';
import { MediaPage } from './pages/MediaPage';
import { UnauthorizedPage } from './pages/UnauthorizedPage';
import { SignedOutPage } from './pages/SignedOutPage';
import { VersionManagmentPage } from './pages/VersionManagmentPage';
import { QuestionnaireAnalyticsPage } from './pages/QuestionnaireAnalyticsPage';
import WeekLogAnalyticsPage from './pages/WeekLogAnalyticsPage';
import { BroadcastListPage } from './pages/BroadcastListPage';
import { BroadcastCreatePage } from './pages/BroadcastCreatePage';
import { BroadcastStatisticsPage } from './pages/BroadcastStatisticsPage';
import { SessionsPage } from './pages/SessionsPage';

// Router
import { Route, Routes } from 'react-router-dom';

// Auth
import { AuthProvider } from './auth/AuthProvider';
import { AuthorizedRoute } from './auth/AuthorizedRoute';
import { UserInfoProvider } from './auth/UserInfoProvider';
import { RoleProtectedRoute } from './auth/RoleProtectedRoute';
import { SIGNED_OUT_PATH } from './auth/signOut';

import { PagePath } from './auth/roleMatrix';
import { TechnicalSupportPage } from './pages/TechnicalSupport';
import TechnicalSupportDetailsPage from './pages/TechnicalSupportDetailsPage';
import { QuestionnairePage } from './pages/QuestionnairePage';
import IstiftaPage from './pages/IstiftaPage';
import IstiftaDetailsPage from './pages/IstiftaDetailsPage';
import { IstiftaLinksPage } from './pages/IstiftaLinksPage';

// Every signed-in page, keyed by its role-matrix path: a page missing from the matrix, or a matrix
// entry with no page, fails to compile.
const PAGES: Record<PagePath, React.ReactElement> = {
  '/': <HomePage />,
  '/week-log-analytics': <WeekLogAnalyticsPage />,
  '/questionnaire/:questionnaireId/analytics': <QuestionnaireAnalyticsPage />,
  '/technical-support': <TechnicalSupportPage />,
  '/technical-support/:id': <TechnicalSupportDetailsPage />,
  '/content': <ContentPage />,
  '/content-context': <ContentContextPage />,
  '/questions': <QuestionsPage />,
  '/answers': <AnswersPage />,
  '/media': <MediaPage />,
  '/questionnaire': <QuestionnairePage />,
  '/istifta': <IstiftaPage />,
  '/istifta/links': <IstiftaLinksPage />,
  '/istifta/:id': <IstiftaDetailsPage />,
  '/user-list': <UserListPage />,
  '/versions-management': <VersionManagmentPage />,
  '/notification-configuration': <NotificationConfigurationPage />,
  '/broadcast': <BroadcastListPage />,
  '/broadcast/create': <BroadcastCreatePage />,
  '/broadcast/:id/stats': <BroadcastStatisticsPage />,
  '/sessions': <SessionsPage />,
};

function App() {
  return (
    <AuthProvider>
      <UserInfoProvider>
        <Routes>
          <Route path="/unauthorized" element={<UnauthorizedPage />} />
          <Route path={SIGNED_OUT_PATH} element={<SignedOutPage />} />
          <Route element={<AuthorizedRoute />}>
            <Route element={<RoleProtectedRoute />}>
              {(Object.keys(PAGES) as PagePath[]).map((path) => (
                <Route key={path} path={path} element={PAGES[path]} />
              ))}
            </Route>
          </Route>
        </Routes>
      </UserInfoProvider>
    </AuthProvider>
  );
}

export default App;
